<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />    
    
    
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    
    
    <b-container fluid="">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span>ETL</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>DX_</div>
        </b-col>
      </b-row>

      <b-row  >
        <b-col class="subtitulos">
          <p>Pantalla de archivos cargados</p> 
        </b-col>
      </b-row>

      <b-row  >
        <b-col cols="12"> <br /><br /> </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <h2>Archivos Cargados</h2>
          <b-table
            hover
            id="Pendientes"
            thead-tr-class="columnas"
            :items="archivosCargadosArray"
            :fields="layoutTablaArchivosCargados"
            responsive
            :per-page="registrosPorPaginaArchivosCargados"
            :current-page="paginaActualTablaArchivosCargados"
          >
            <template v-slot:cell(fechaAlta)="row">
              {{ row.item.fechaAlta | formatoFechaHoraTexto}}
            </template>
            <template v-slot:cell(fechaModificacion)="row">
              {{ row.item.fechaModificacion | formatoFechaHoraTexto}}
            </template>
            <template v-slot:cell(visualizar)="row">
              <b-button
                @click="
                  obtenerDatosDelArchivoSeleccionado(
                    row.item.idArchivoCarga,
                    1,
                    true
                  )
                "
                variant="primary"
                >Cargar datos</b-button
              >
            </template>
          </b-table>
          <b-pagination
            align="center"
            v-model="paginaActualTablaArchivosCargados"
            :total-rows="datosTablaRowArchivosCargados"
            :per-page="registrosPorPaginaArchivosCargados"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>

      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info"
              >Tabla temporal</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-1"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
                
                
            <b-row>
                
                <b-col cols="4">
                </b-col>
                <b-col cols="4">
                  <h2>Errores En el proceso</h2>

                  <download-excel
                    v-if="datosErroresArrayJson.length > 0"
                    :disabled="!permitirDescargaExcelErrores"
                   
                    class="btn btn-primary"
                    :data="datosErroresArrayJson"
                    :fields="layoutExcelErrores"
                    worksheet="My Worksheet"
                    :name="'Errores ' + nombreArchivo + '.xls'"
                  >
                    Generar Excel {{nombreArchivo}}
                    <em class="fa fa-file-excel-o"></em>
                  </download-excel>
                   <b-button
                v-else 
                        disabled class="btn-block" variant="secondary "
                        >No hay errores</b-button
                      >
                </b-col>
               
              </b-row>



              <b-row>
                <b-col cols="12">
                  <hr />
                  <br />
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="4"> </b-col>
                <b-col cols="4">
                  <h2>Busqueda por nombre</h2>
                  <b-form
                    v-on:submit.prevent="
                      obtenerRegistrosDelArchivoSeleccionadoPorNombre
                    "
                  >
                    <b-form-group id="input-group-1" label="Nombre:">
                      <b-form-input
                        id="input-1"
                        v-model="nombre"
                        type="text"
                        placeholder="Ingrese el nombre"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <div v-if="idArchivoCarga != null">
                      <b-button
                        type="submit"
                        class="btn-block"
                        variant="success"
                        >Buscar</b-button
                      >
                      <br />
                      <b-button
                        v-if="busquedaPorNombre"
                        type="button"
                        class="btn-block"
                        @click="
                          obtenerDatosDelArchivoSeleccionado(
                            idArchivoCarga,
                            1,
                            true
                          )
                        "
                        variant="primary"
                        >Cargar datos nuevamente</b-button
                      >
                    </div>
                    <div v-else>
                      <b-button disabled class="btn-block" variant="secondary "
                        >Seleccione un archivo para cargar</b-button
                      >
                    </div>
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <hr />
                  <br />
                </b-col>
              </b-row>

              <!-- Tabla busqueda general -->

              <b-row v-if="!busquedaPorNombre">
                <b-col cols="12">
                  <h3>Tabla datos cargados del excel en la tabla temporal</h3>
                  Número de Registros: {{ datosTablaRowEtlTemporal }}
                  <br />
                </b-col>
                <b-col cols="12">
                  <br />
                  <b-table
                    hover
                    id="Pendientes"
                    thead-tr-class="columnas"
                    :items="datosEtlTemporalArray"
                    :fields="layoutTabladatosEtlTemporal"
                    responsive
                    :per-page="registrosPorPaginaEtlTemporal"
                    :current-page="paginaActualTablaEtlTemporalPaginacion"
                  >
                    <template v-slot:cell(fechaNacimiento)="row">
                      {{ row.item.fechaNacimiento | formatoFecha }}
                    </template>

                    <template v-slot:cell(inicioVigencia)="row">
                      {{ row.item.inicioVigencia | formatoFecha }}
                    </template>

                    <template v-slot:cell(finVigencia)="row">
                      {{ row.item.finVigencia | formatoFecha }}
                    </template>

                    <template v-slot:cell(fechaAlta)="row">
                      {{ row.item.fechaAlta | formatoFecha }}
                    </template>
                    
                  </b-table>
                  <b-pagination
                    align="center"
                    v-model="paginaActualTablaEtlTemporal"
                    :total-rows="datosTablaRowEtlTemporalPaginacion"
                    :per-page="registrosPorPaginaEtlTemporal"
                  ></b-pagination>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <hr />
                </b-col>
              </b-row>

              <!-- Tabla busqueda por nombre -->
              <b-row v-if="busquedaPorNombre">
                <b-col cols="12">
                  <h3>
                    Tabla datos cargados del excel en la tabla temporal(busqueda
                    por nombre)
                  </h3>

                  Número de Registros: {{ datosTablaRowEtlTemporalNombre }} con
                  el nombre: {{ nombre }}
                  <br />
                </b-col>
                <b-col cols="12">
                  <br />
                  <b-table
                    hover
                    id="Pendientes"
                    thead-tr-class="columnas"
                    :items="datosEtlTemporalArrayNombre"
                    :fields="layoutTabladatosEtlTemporal"
                    responsive
                    :per-page="registrosPorPaginaEtlTemporalNombre"
                    :current-page="paginaActualTablaEtlTemporalNombre"
                  >
                    <template v-slot:cell(fechaNacimiento)="row">
                      {{ row.item.fechaNacimiento | formatoFecha }}
                    </template>

                    <template v-slot:cell(inicioVigencia)="row">
                      {{ row.item.inicioVigencia | formatoFecha }}
                    </template>

                    <template v-slot:cell(finVigencia)="row">
                      {{ row.item.finVigencia | formatoFecha }}
                    </template>

                    <template v-slot:cell(fechaAlta)="row">
                      {{ row.item.fechaAlta | formatoFecha }}
                    </template>
                    
                  </b-table>
                  <b-pagination
                    align="center"
                    v-model="paginaActualTablaEtlTemporalNombre"
                    :total-rows="datosTablaRowEtlTemporalNombre"
                    :per-page="registrosPorPaginaEtlTemporalNombre"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card> 
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2 variant="info"
              >Guardado Final</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-row>
                <b-col cols="4"> </b-col>
                <b-col cols="4">
                  <h2>Busqueda por nombre</h2>
                  <b-form
                    v-on:submit.prevent="obtenerRegistrosFinalesPorNombre"
                  >
                    <b-form-group id="input-group-1" label="Nombre:">
                      <b-form-input
                        id="input-1"
                        v-model="nombreFinal"
                        type="text"
                        placeholder="Ingrese el nombre"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <div>
                      <b-button
                        type="submit"
                        class="btn-block"
                        variant="success"
                        >Buscar</b-button
                      >
                      <br />
                    </div>
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <hr />
                </b-col>
              </b-row>

              <!-- Tabla busqueda por nombre -->
              <b-row>
                <b-col cols="12">
                  <h3>Tabla de pacientes en el sistema</h3>

                  Número de Registros: {{ datosTablaRowEtlFinalNombre }}
                  <br />
                </b-col>
                <b-col cols="12">
                  <br />
                  <b-table
                    hover
                    id="Pendientes"
                    thead-tr-class="columnas"
                    :items="datosEtlFinalArrayNombre"
                    :fields="layoutTabladatosEtlFinalNombre" 
                    responsive
                    :per-page="registrosPorPaginaEtlTemporalNombre"
                    :current-page="paginaActualTablaEtlFinalNombre"
                  >
                    <template v-slot:cell(fechaNacimiento)="row">
                      {{ row.item.fechaNacimiento | formatoFecha }}
                    </template>

                    <template v-slot:cell(inicioVigencia)="row">
                      {{ row.item.inicioVigencia | formatoFecha }}
                    </template>

                    <template v-slot:cell(finVigencia)="row">
                      {{ row.item.finVigencia | formatoFecha }}
                    </template>

                    <template v-slot:cell(fechaAlta)="row">
                      {{ row.item.fechaAlta | formatoFecha }}
                    </template>
                     
                    <template v-slot:cell(planActivo)="row">  
                      <b-alert v-if="row.item.planActivo" show variant="primary"
                        >ACTIVO</b-alert
                      >
                      <b-alert v-else show variant="secondary">INACTIVO</b-alert>
                    </template>
                    
                    
                    
                    
                  </b-table>
                  <b-pagination
                    align="center"
                    v-model="paginaActualTablaEtlFinalNombre"
                    :total-rows="datosTablaRowEtlFinalNombre"
                    :per-page="registrosPorPaginaEtlTemporalNombre"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card><br /> <br /> <br /> 
      </div>

 
 
      <b-row>
        <b-col> <br /><br /><br /><br /><br /><br /> <br /> <br /> <br /> </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Swal from "sweetalert2";

export default {
  name: "etl",
  components: {
    Header,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    loading : false,
    idArchivoCarga: null,
    nombreArchivo: null,
    // ------
    // tabla archivos cargados
    // ------
    archivosCargadosArray: [],
    layoutTablaArchivosCargados: [
      {
        key: "idArchivoCarga",
        label: "Id",
        sortable: true,
      },
      {
        key: "nombreEmpresa",
        label: "Empresa",
        sortable: true,
      },
      {
        key: "nombre",
        label: "Nombre del Archivo",
        sortable: true,
      },
      {
        key: "progreso",
        label: "Estatus del proceso",
        sortable: true,
      },
      {
        key: "fechaAlta",
        label: "Fecha Alta",
        sortable: true,
      },
      {
        key:"fechaModificacion",
        label: "Fecha Finalización",
        sortable: true,
      },
      {
        key: "visualizar",
        label: "Visualizar",
        sortable: true,
      },
    ],

    registrosPorPaginaArchivosCargados: 10,
    paginaActualTablaArchivosCargados: 1,
    datosTablaRowArchivosCargados: 0,

    // ------
    // tabla datos etl temporal
    // ------

    datosEtlTemporalArray: [],
    layoutTabladatosEtlTemporal: [ 
      {
        key: "idArchivoCarga",
        label: "id Archivo Carga",
        sortable: true,
      },
      {
        key: "nombrePestania",
        label: "Nombre Pestaña",
        sortable: true,
      },
      {
        key: "numeroFila",
        label: "Número Fila",
        sortable: true,
      },
      {
        key: "idPlan",
        label: "Id Plan",
        sortable: true,
      },
      {
        key: "nombrePlan",
        label: "Nombre Plan",
        sortable: true,
      },
      {
        key: "nombre",
        label: "Nombre",
        sortable: true,
      },
      {
        key: "paterno",
        label: "Paterno",
        sortable: true,
      },
      {
        key: "materno",
        label: "Materno",
        sortable: true,
      },
      {
        key: "fechaNacimiento",
        label: "Fecha Nacimiento",
        sortable: true,
      },
      {
        key: "nombreSexo",
        label: "Sexo",
        sortable: true,
      },
      {
        key: "idPaciente",
        label: "Id Paciente",
        sortable: true,
      },
      {
        key: "clavePaciente",
        label: "Clave Paciente",
        sortable: true,
      },
      {
        key: "hashseedPaciente",
        label: "Hashseed Paciente",
        sortable: true,
      },
      {
        key: "numeroPoliza",
        label: "Número Póliza",
        sortable: true,
      },
      {
        key: "inicioVigencia",
        label: "Inicio Vigencia",
        sortable: true,
      },
      {
        key: "finVigencia",
        label: "Fin Vigencia",
        sortable: true,
      },
      {
        key: "idAgente",
        label: "Id Agente",
        sortable: true,
      },
      {
        key: "claveAgente",
        label: "Clave Agente",
        sortable: true,
      },
      {
        key: "nombreAgente",
        label: "Nombre Agente",
        sortable: true,
      },
      {
        key: "idTerritorio",
        label: "Id Territorio",
        sortable: true,
      },
      {
        key: "nombreTerritorio",
        label: "Nombre Territorio",
        sortable: true,
      },
      {
        key: "idRegion",
        label: "Id Region",
        sortable: true,
      },
      {
        key: "nombreRegion",
        label: "Nombre Region",
        sortable: true,
      },
      {
        key: "idOficina",
        label: "Id Oficina",
        sortable: true,
      },
      {
        key: "nombreOficina",
        label: "Nombre Oficina",
        sortable: true,
      },
      {
        key: "idCanalTipo",
        label: "Id Canal Tipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "Nombre Canal Tipo",
        sortable: true,
      },
      {
        key: "idCanal",
        label: "idCanal",
        sortable: true,
      },
      {
        key: "nombreCanal",
        label: "nombreCanal",
        sortable: true,
      },
      {
        key: "idPromotorClave",
        label: "idPromotorClave",
        sortable: true,
      },
      {
        key: "promotorKey",
        label: "promotorKey",
        sortable: true,
      },
      {
        key: "idPromocion",
        label: "idPromocion",
        sortable: true,
      },
      {
        key: "nombrePromocion",
        label: "nombrePromocion",
        sortable: true,
      },
      {
        key: "idEstado",
        label: "idEstado",
        sortable: true,
      },
      {
        key: "nombreEstado",
        label: "nombreEstado",
        sortable: true,
      },
      {
        key: "idMunicipio",
        label: "idMunicipio",
        sortable: true,
      },
      {
        key: "nombreMunicipio",
        label: "nombreMunicipio",
        sortable: true,
      },
      {
        key: "fechaAlta",
        label: "fechaAlta",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      }, 
    ],
    registrosPorPaginaEtlTemporal: 100,
    paginaActualTablaEtlTemporal: 1,
    datosTablaRowEtlTemporal: 0,
    paginaActualTablaEtlTemporalPaginacion: 1,
    datosTablaRowEtlTemporalPaginacion: 0,
    // ------
    //
    // ------
    busquedaPorNombre: false,
    nombre: null,

    datosEtlTemporalArrayNombre: [],
    datosEtlTemporalArrayOriginalNombre: [],
    registrosPorPaginaEtlTemporalNombre: 100,
    paginaActualTablaEtlTemporalNombre: 1,
    datosTablaRowEtlTemporalNombre: 0,

    // ------
    //
    // ------
    nombreFinal: null,
    datosEtlFinalArrayNombre: [],
    datosTablaRowEtlFinalNombre: 0,
    paginaActualTablaEtlFinalNombre: 1,
    
    layoutTabladatosEtlFinalNombre: [   
      {
        key: "planActivo",
        label: "Estatus Paciente-Plan",
        sortable: true,
      },   
      {
        key: "idPlan",
        label: "Id Plan",
        sortable: true,
      },
      {
        key: "nombrePlan",
        label: "Nombre Plan",
        sortable: true,
      },
      {
        key: "nombre",
        label: "Nombre",
        sortable: true,
      },
      {
        key: "paterno",
        label: "Paterno",
        sortable: true,
      },
      {
        key: "materno",
        label: "Materno",
        sortable: true,
      },
      {
        key: "fechaNacimiento",
        label: "Fecha Nacimiento",
        sortable: true,
      },
      {
        key: "nombreSexo",
        label: "Sexo",
        sortable: true,
      },
      {
        key: "idPaciente",
        label: "Id Paciente",
        sortable: true,
      }, 
      {
        key: "numeroPoliza",
        label: "Número Póliza",
        sortable: true,
      },
      {
        key: "inicioVigencia",
        label: "Inicio Vigencia",
        sortable: true,
      },
      {
        key: "finVigencia",
        label: "Fin Vigencia",
        sortable: true,
      },
      {
        key: "idAgente",
        label: "Id Agente",
        sortable: true,
      },
      {
        key: "claveAgente",
        label: "Clave Agente",
        sortable: true,
      },
      {
        key: "nombreAgente",
        label: "Nombre Agente",
        sortable: true,
      },
      {
        key: "idTerritorio",
        label: "Id Territorio",
        sortable: true,
      },
      {
        key: "nombreTerritorio",
        label: "Nombre Territorio",
        sortable: true,
      },
      {
        key: "idRegion",
        label: "Id Region",
        sortable: true,
      },
      {
        key: "nombreRegion",
        label: "Nombre Region",
        sortable: true,
      },
      {
        key: "idOficina",
        label: "Id Oficina",
        sortable: true,
      },
      {
        key: "nombreOficina",
        label: "Nombre Oficina",
        sortable: true,
      },
      {
        key: "idCanalTipo",
        label: "Id Canal Tipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "Nombre Canal Tipo",
        sortable: true,
      },
      {
        key: "idCanal",
        label: "idCanal",
        sortable: true,
      },
      {
        key: "nombreCanal",
        label: "nombreCanal",
        sortable: true,
      },
      {
        key: "idPromotorClave",
        label: "idPromotorClave",
        sortable: true,
      },
      {
        key: "promotorKey",
        label: "promotorKey",
        sortable: true,
      },
      {
        key: "idPromocion",
        label: "idPromocion",
        sortable: true,
      },
      {
        key: "nombrePromocion",
        label: "nombrePromocion",
        sortable: true,
      },
      {
        key: "idEstado",
        label: "idEstado",
        sortable: true,
      },
      {
        key: "nombreEstado",
        label: "nombreEstado",
        sortable: true,
      },
      {
        key: "idMunicipio",
        label: "idMunicipio",
        sortable: true,
      },
      {
        key: "nombreMunicipio",
        label: "nombreMunicipio",
        sortable: true,
      },
      {
        key: "fechaAlta",
        label: "fechaAlta",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      }, 
    ],
    // ------
    //
    // ------
    permitirDescargaExcelErrores: false,
    datosErroresArrayJson: [],
    layoutExcelErrores: {
      "Nombre Pestaña": "nombrePestania",
      "Numero Fila": "numeroFila",
      Error: "error",
    },

    // ------
    //
    // ------

    // ------
    //
    // ------
  
  }),

  mounted() {
    // this.getObtenerDatosBandeja("A", 1, true);
    this.archivosCargados();
  },
  methods: {
    archivosCargados() {
      this.showAlert();

      this.archivosCargadosArray = [];
      this.datosTabla = [];
      this.$http
        .get(this.$api + "etl/etlarchivocargas")
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.archivosCargadosArray = response.data.data;
          this.datosTablaRowArchivosCargados =
            this.archivosCargadosArray.length;
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        })
        .finally((Swal.close()));
    },

    obtenerDatosDelArchivoSeleccionado(
      idArchivoCarga,
      pagina,
      actualizarTodaLaTabla
    ) {
      this.permitirDescargaExcelErrores = false;
      this.busquedaPorNombre = false;
      this.showAlert();
      this.datosEtlTemporalArray = [];
      this.idArchivoCarga = idArchivoCarga;

      if (actualizarTodaLaTabla) {
        this.paginaActualTablaEtlTemporal = pagina;
        this.paginaActualTablaEtlTemporalPaginacion = pagina;
        this.datosTablaRowEtlTemporalPaginacion = 0;
      }

      const param = {
        idArchivoCarga: idArchivoCarga,
        paginaActual: this.paginaActualTablaEtlTemporal
      }
      this.$http
        .post(
          this.$api +
            "etl/etltemporal/poridarchivocarga",
            param
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.datosEtlTemporalArray = response.data.data;
          this.datosTablaRowEtlTemporalPaginacion = this.datosTablaRowEtlTemporal;
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        })
        .finally( 
          this.obtenerTotalRegistrosDelArchivoSeleccionado(idArchivoCarga),
          this.obtenerErroresDelArchivoSeleccionado(idArchivoCarga)
        );
    },

    obtenerTotalRegistrosDelArchivoSeleccionado(idArchivoCarga) {
       
      this.datosTablaRowEtlTemporal = 0;

      this.$http
        .post(
          this.$api +
            "etl/etltemporal/poridarchivocarga/numeroregistros",
            idArchivoCarga
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.datosTablaRowEtlTemporal = response.data.data;
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        })
        .finally((Swal.close()));
    },

    obtenerRegistrosDelArchivoSeleccionadoPorNombre() {
      this.showAlert();
      this.busquedaPorNombre = true;

      this.datosEtlTemporalArrayNombre = [];
      this.datosTablaRowEtlTemporalNombre = 0;
      let data = {
        'idArchivoCarga':this.idArchivoCarga,
        'nombre': this.nombre
      }
      this.$http
        .post(
          this.$api +
            "etl/etltemporal/busquedapaciente",
            data
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.datosEtlTemporalArrayNombre = response.data.data;
          this.datosTablaRowEtlTemporalNombre = response.data.data.length;
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        })
        .finally((Swal.close()));
    },

    obtenerRegistrosFinalesPorNombre() {
      this.showAlert();
      this.busquedaPorNombre = true;

      this.datosEtlFinalArrayNombre = [];
      this.datosTablaRowEtlFinalNombre = 0;

      //   this.datosEtlTemporalArrayNombre = [];
      // datosTablaRowEtlTemporalNombre
      this.$http
        .get(
          this.$api +
            "etl/guardadoenbd/busquedapaciente?nombre=" +
            this.nombreFinal
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.datosEtlFinalArrayNombre = response.data.data;
          this.datosTablaRowEtlFinalNombre = response.data.data.length;
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        })
        .finally((Swal.close()));
    },

    obtenerErroresDelArchivoSeleccionado(idArchivoCarga) {
      this.datosErroresArrayJson = [];

      this.$http
        .post(
          this.$api +
            "etl/etltemporal/errores/poridarchivocarga",
            idArchivoCarga
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray

          this.datosErroresArrayJson = JSON.parse(
            JSON.stringify(response.data.data)
          );
          
          var archivo = this.archivosCargadosArray.find( archivo => archivo.idArchivoCarga == this.idArchivoCarga ); 
          this.nombreArchivo = archivo.nombreEmpresa;
          
          
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        })
        .finally((this.permitirDescargaExcelErrores = true));
    },
    
    
    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },
    
    
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.resource = {
      idEstatusSolicitud: null,
      arrayEspecialidades: [],
      arrayEspecialistas: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();

    var dia1 = new Date();
    dia1.setDate(dia1.getDate() - 3);
    dia1.setHours(0, 0, 0, 0);
    this.fechaInicio = this.$moment(dia1)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  },
  computed: {},
  watch: {
    paginaActualTablaEtlTemporal() {
      this.obtenerDatosDelArchivoSeleccionado(
        this.idArchivoCarga,
        this.paginaActualTablaEtlTemporal,
        false
      );
    },
    paginaActualTablaErrores() {
      this.obtenerErroresDelArchivoSeleccionado(this.idArchivoCarga);
    },
  },
};
</script>
